/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFeedbackBatchGetResponseFeedback } from "../../funcs/llmFeedbackBatchGetResponseFeedback.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.BatchGetResponseFeedbackRequest$inboundSchema,
};

export const tool$llmFeedbackBatchGetResponseFeedback: ToolDefinition<
  typeof args
> = {
  name: "llm-feedback-batch-get-response-feedback",
  description: `Batch retrieve feedback for multiple responses

Retrieves feedback for multiple agent responses in a single batch request.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFeedbackBatchGetResponseFeedback(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
